import React, { useState, useEffect } from 'react';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    SelectBeneficiary as BENE_SELECT,
    DeleteBeneficiary as BENI_DELETE,
    MoneyTransfer as MONEY_TRANSFER,
    GetSplitAmountForTransactionKYCPPI as GETSPLITAMOUNT
} from 'Components/Api/KYCPPIAPI';
import { LOGOUT } from 'ConstComponents';
import * as Yup from 'yup';
import { PAY_POINT_CODE } from 'Components/Helper/Messages';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
import {
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import usePosition from 'Components/Posistion';
import { useHistory } from 'react-router';
import { PPITransactionConfirmation } from 'Components/Alert/PPITransactionConfirmation';
import { OTPModal } from 'Components/Modal/OTPModal';
import { useLocation } from 'react-router-dom';

export default function BeneficiaryList({
    senderID,
    senderName,
    senderMobile,
    setIsError,
    setSeverity,
    setLoading,
    setResponseMessage,
    formRef
}) {
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();
    const [mainColumns, setMainColumns] = useState([]);
    const [list, setList] = useState([]);
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isPin] = useState(localStorage.getItem('IsPin'));
    const [ResponseAlert, setResponseAlert] = useState({});
    const [serviceCode, setserviceCode] = useState(PAY_POINT_CODE);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const { latitude, longitude } = usePosition();
    const [isOtpDialogOpen, setIsOtpDialogOpen] = useState(false);
    const [openOTP, setOpenOTP] = useState(false);
    const [VerifyOTPParams, setVerifyOTPParams] = useState();
    const [modalErrorMessage, setModalErrorMessage] = useState('');
    const DMTName = location?.state?.DMTName;  
    useEffect(() => {
        createColumns();
        select();
    }, [senderID]);

    const select = async () => {
        setList([]);
        setLoading(true);
        setIsError(false);
        if (senderID === undefined) return;

        if (senderID === '') return;

        var beneReqObj = JSON.stringify({
            SenderID: senderID,
        });

        setLoading(false);
        setList([]);
        var response = await BENE_SELECT(beneReqObj);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);

        if (data.length < 0) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage('No Beneficiary Found');
            return;
        }

        setList(data);
    };
    const GetSplitAmountForMultipleTransaction = async (request) => {
        setIsOtpDialogOpen(false);
        let jsonObj = {
            Mobile: senderMobile,
            BeneMobile: request.BeneMobile,
            Name: request.BeniName,
            BeniName: request.BeniName,
            SenderName: senderName,
            BankName: request.BankName,
            AccountNo: request.AccountNumber,
            IFSC: request.IFSC,
            BeneficiaryID: request.BeneficiaryID,
            SenderID: request.SenderID,
            PaymentType: request.PaymentType,
            RechargePin: request.RechargePin,
            Remark: request.Remark,
            Amount: request.Amount,
            DMTName: DMTName,
        };
        setIsError(false);
        setLoading(true);

        var apirequest = JSON.stringify(jsonObj);
        var response = await GETSPLITAMOUNT(apirequest);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            select();
            return;
        }
        var data = JSON.parse(response.data);
        let params = {
            MainRequest: jsonObj,
            OTPListRequest: data,
            Mobile: senderMobile,
            DMTName: DMTName,
        };
        history.push('/KYCPPI_SplitAmount', params);
        return;
    };

    const GenerateTransferOTP = async (request) => {
        setIsOtpDialogOpen(false);
        let jsonObj = {
            Mobile: senderMobile,
            BeneMobile: request.BeneMobile,
            Name: request.BeniName,
            BeniName: request.BeniName,
            SenderName: senderName,
            BankName: request.BankName,
            AccountNo: request.AccountNumber,
            IFSC: request.IFSC,
            BeneficiaryID: request.BeneficiaryID,
            SenderID: request.SenderID,
            PaymentType: request.PaymentType,
            RechargePin: request.RechargePin,
            Remark: request.Remark,
            DMTName: DMTName,
            IsVerify: request.isVerify,
            OriginalAmount: request.Amount,
            PublicIP: request.PublicIP,
            Latitude: latitude,
            Longitude: longitude,
            OTP: request.OTP,
        };
        setIsError(false);
        setLoading(true);
        var apirequest = JSON.stringify(jsonObj);
        var response = await MONEY_TRANSFER(apirequest); 
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            select();
            return;
        }
        var data = JSON.parse(response.data);
        let OTPVerifyRequest = data.list;
        let paramsForVerify = {
            MainRequest: request,
            OTPListRequest: OTPVerifyRequest
        };
        if (jsonObj.OriginalAmount === 1) {
            setIsOtpDialogOpen(false);
            setOpenOTP(true);
            setVerifyOTPParams(paramsForVerify);
        } else {
            let params = {
                MainRequest: jsonObj,
                DMTName: DMTName,
                OTPListRequest: data.list,
                Latitude: latitude,
                Longitude: longitude
            };

            history.push('/KYCPPI_TransactionConfirmation', params);

            jsonObj.OTPToken = data.OTPRefid;
            setConfirmAlertRequest(jsonObj);
            setIsOtpDialogOpen(true);
        }
    };

    const VerifyConfirmation = async (values) => {
        setConfirmAlertRequest({});
        let SenderID = values[10];
        let BankID = values[11];
        let RechargePin = values[6];
        if (isPin !== 'true') {
            SenderID = values[9];
            RechargePin = '';
            BankID = values[10];
        }

        if (RechargePin === undefined) {
            RechargePin = '';
        }
        let jsonObj = {
            BeneficiaryID: values[0],
            BeniName: values[1],
            BankName: values[2],
            AccountNumber: values[3],
            IFSC: values[4],
            Amount: 1,
            RechargePin: RechargePin,
            SenderID: SenderID,
            BankID: BankID,
            OperatorID: values.OperatorID,
            ServiceID: PAY_POINT_CODE,
            Latitude: latitude,
            Longitude: longitude,
            DMTName: DMTName
        };

        var errorValidation = false;

        await MTTransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);
            setIsError(true);
            return;
        });

        if (errorValidation === true) return;

        setIsAlertOpen(true);
        setConfirmAlertRequest(jsonObj);
    };

    const MTTransferConfirmation = async (values) => {
        setConfirmAlertRequest({});
        let SenderID = values[10];
        let RechargePin = values[6];
        if (isPin !== 'true') {
            SenderID = values[9];
            RechargePin = '';
        }
        if (RechargePin === undefined) {
            RechargePin = '';
        }
        let jsonObj = {
            BeneficiaryID: values[0],
            BeniName: values[1],
            BankName: values[2],
            AccountNumber: values[3],
            IFSC: values[4],
            Amount: values[5],
            RechargePin: RechargePin,
            SenderID: SenderID,
            OperatorID: values[7],
            ServiceID: PAY_POINT_CODE,
            Latitude: latitude,
            Longitude: longitude,
            DMTName: DMTName
        };

        setIsError(false);

        var errorValidation = false;

        await MTTransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);

            setIsError(true);
            return;
        });

        if (errorValidation === true) return;

        setIsAlertOpen(true);
        setConfirmAlertRequest(jsonObj);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'BeneficiaryID',
            srno: true
        });

        columns.push({
            label: 'Name',
            name: 'Name',
            bold: true
        });
        columns.push({
            label: 'Bank',
            name: 'BankName'
        });
        columns.push({
            label: 'AccountNo',
            name: 'AccountNo',
            bold: true
        });

        columns.push({
            label: 'IFSC',
            name: 'IFSC'
        });
        columns.push({
            label: 'Amount',
            name: 'Amount',
            length: 6,
            editableWithNumberOnly: true
        });
        if (isPin === 'true') {
            columns.push({
                label: 'Pin',
                name: 'RechargePin',
                editableWithPinOnly: true,
                length: 4
            });
        }
        columns.push({
            label: 'Verified',
            name: 'IsVerified',
            buttonTitle: 'Verify',
            buttonOrLabel: true,
            callback: (values) => {
                VerifyConfirmation(values);
            }
        });
        columns.push({
            label: 'Transfer',
            name: 'BeneficiaryID',
            transfer: true,
            buttonTitle: 'Transfer',
            callback: (value) => {
                MTTransferConfirmation(value);
            }
        });

        columns.push({
            label: 'Delete',
            name: 'BeneficiaryID',
            icon: 'DeleteIcon',
            iconButtonWithRow: true,
            callback: (value) => {
                Delete(value);
            }
        });
        columns.push({
            label: 'SenderID',
            name: 'SenderID',
            hide: true
        });
        setMainColumns(columns);
    };

    const Verify = async (values) => {
        setOpenOTP(false);

        var jsonObj = {
            BeneficiaryID: values.BeneficiaryID,
            Name: values.BeniName,
            SenderName: senderName,
            BankName: values.BankName,
            BankID: values.BankID,
            AccountNo: values.AccountNumber,
            IFSC: values.IFSC,
            SenderID: values.SenderID,
            Mobile: senderMobile,
            PaymentType: 'IMPS',
            Through: 'WEB',
            IsVerify: true,
            Amount: 1,
            RechargePin: values.RechargePin,
            Latitude: latitude,
            Longitude: longitude,
            ServiceID: PAY_POINT_CODE,
            DMTName: DMTName,
        };

        setLoading(true);
        setIsError(false);

        try {
            var request = JSON.stringify(jsonObj);
            var response = await MONEY_TRANSFER(request); 
            setLoading(false);

            if (!response.isAuthorized) {
                LOGOUT();
                return;
            }

            if (!response.status) {
                var dataError = JSON.parse(response.data);
                setSeverity('error');
                setResponseMessage(dataError.Message);
                setIsError(true);
                select();
                return;
            }

            var data = JSON.parse(response.data);
            setSeverity('success');
            setResponseMessage(data.Message);
            setIsError(true);

            if (formRef.current) formRef.current.handleSubmit();

            if (data.Status === 'FAILURE') {
                setSeverity('error');
                select();
            }
        } catch (error) {
            console.error("API Error:", error);
            setLoading(false);
            setSeverity('error');
            setResponseMessage("An error occurred during the transaction");
            setIsError(true);
        }
    };

    const Delete = async (values) => {
        let SenderID = values[10];
        if (isPin !== 'true') {
            SenderID = values[9];
        }
        var request = {
            BeneficiaryID: values[0],
            SenderID: SenderID,
        };
        setLoading(true);
        setIsError(false);
        var requestObj = JSON.stringify(request);

        var response = await BENI_DELETE(requestObj);

        setLoading(false);
        if (!response.isAuthorized) LOGOUT();
        setIsError(true);
        setResponseMessage(response.data);
        if (!response.status) {
            setSeverity('error');
            select();
            return;
        }
        select();
        setSeverity('success');
        if (formRef.current) formRef.current.handleSubmit();
    };

    const MTTransferValidation = Yup.object({
        BeniName: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),
        BeneficiaryID: Yup.string().required(PLEASE_PROVIDE_VALID + 'bene'),
        SenderID: Yup.string().required(PLEASE_PROVIDE_VALID + 'sender'),
        BankName: Yup.string().required(PLEASE_PROVIDE_VALID + 'bank'),

        AccountNumber: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC'),

        Amount: Yup.number()
            .required(PLEASE_PROVIDE_VALID + 'amount')
            .min(0, PLEASE_PROVIDE_VALID + 'amount'),

        RechargePin: Yup.string().when(['IsPin'], {
            is: (isPin) => isPin === 'true',

            then: Yup.string().required('Please enter pin')
        })
    });

    const sendCallback = (data) => {
        setIsResponseAlertOpen(false);
        setSeverity('success');
        if (data.Status === 'FAILURE') {
            setSeverity('error');
        }
        select();
        var param = {
            Mobile: data.Mobile,
        };
        history.push('/KYCPPI_SenderSearch', param);
    };

    if (
        senderMobile === undefined ||
        senderMobile === null ||
        senderMobile.length <= 5
    ) {
        return null;
    }

    return (
        <>
            <h2 className={classes.PaperHead_h2}>Beneficiary List</h2>

            <ReactTable data={list} columns={mainColumns} rowsPerPage={10} />

            {isAlertOpen ? (
                <PPITransactionConfirmation
                    isOpen={isAlertOpen}
                    ActiveDMTName={DMTName}
                    title="PPI Money Transfer"
                    message="Are you sure to do this transaction?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        if (parseInt(request.Amount) === 1) {
                            const updatedRequest = {
                                ...request,
                                Amount: 1
                            };
                            Verify(updatedRequest);
                        }
                        else if (parseInt(request.ServiceID) === PAY_POINT_CODE) {
                            GetSplitAmountForMultipleTransaction(request);
                        }
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                        select();
                    }}
                />
            ) : null}

            {isOtpDialogOpen && (
                <PPITransactionConfirmation
                    isOpen={isOtpDialogOpen}
                    title="PPI Transfer"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsOtpDialogOpen(false);
                        Verify(request);
                    }}
                    negativeButtonClick={() => {
                        setIsOtpDialogOpen(false);
                        select();
                    }}
                />
            )}

            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    title={ResponseAlert.Status}
                    ServiceID={serviceCode}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        sendCallback(ResponseAlert);
                    }}
                />
            ) : null}

            {openOTP ? (
                <OTPModal
                    isOpen={openOTP}
                    title="OTP"
                    request={VerifyOTPParams}
                    error={modalErrorMessage}
                    submitCallback={(e) => {
                        GenerateTransferOTP(e);
                        setOpenOTP(false);
                    }}
                    onDismissCallback={(value) => {
                        setOpenOTP(value);
                    }}
                />
            ) : null}

        </>
    );
}
